// src/web/components/announces-item.jsx

import React from 'react'
import { convertEmojiHTML } from '../../helpers/emoji-helpers'
import {
  ListItem,
} from 'react-toolbox/lib/list'
import wrapedListTheme from './themes/announces-list.css'
import DiaryTimestamp from './diary-timestamp.jsx'

class AnnouncesItem extends React.Component {
  openURL = (url) => window.open(url)
  render() {
    const {
      key,
      isUnread,
      announce,
    } = this.props
    const {
      start_at,
      text,
      url,
      icon_url
    } = announce
    const description = convertEmojiHTML(text).replace(/\r?\n/g, '<br>')

    return (
      <ListItem selectable
          key={key}
          className={isUnread ? 'unread' : ''}
          onClick={()=> this.openURL(url)}
          caption={<DiaryTimestamp timestamp={start_at}/>}
          legend={<span dangerouslySetInnerHTML={{__html: description}} />}
          avatar={icon_url}
          theme={wrapedListTheme} />
    )
  }
}

export default AnnouncesItem



// WEBPACK FOOTER //
// ./src/web/components/announces-item.jsx